export default __webpack_public_path__ + "icon_roadside_assistance.e6c81fe0a1a701e09097998985529ad2.svg";